<template>
  <div>
<!--    <HeaderComponent/>-->
    <!-- Replace <HeaderComponent/> with this floating header -->
    <header class="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md shadow-lg transition-all duration-300">
      <div class="container mx-auto px-4">
        <div class="flex items-center justify-between py-3">
          <!-- Logo -->
          <div class="flex-shrink-0">
            <img src="https://cdn.arrify.com/wp-content/uploads/2022/05/cropped-Arrify_Text_small.png" alt="Arrify Logo" class="h-8 w-auto">
          </div>

          <!-- CTA Button -->
          <a href="#contact"
             class="bg-amber-500 hover:bg-amber-600 text-white px-6 py-2 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all transform hover:-translate-y-0.5">
            Get Started
          </a>
        </div>
      </div>
    </header>
    <main class="bg-gray-50 pt-16">




    <!-- Hero Section -->
<section class="relative py-12 md:py-20 bg-white ">
        <div class="container mx-auto px-4">
          <div class="flex flex-col md:flex-row items-center">
            <div class="w-full md:w-1/2 mb-12 md:mb-0">
              <h1 class="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-800 mb-4 md:mb-6 text-center md:text-left">
                Custom Salesforce-WordPress Integration Solutions
              </h1>
              <h2 class="text-xl sm:text-2xl text-blue-600 mb-6 md:mb-8 text-center md:text-left">Built for Your Exact Needs</h2>
              <p class="text-base sm:text-lg text-gray-600 mb-8 text-center md:text-left">
                Transform how your WordPress and Salesforce systems work together with tailor-made integrations. No
                rigid subscriptions, no one-size-fits-all approaches - just custom solutions that perfectly match your
                business requirements.
              </p>
              <div class="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                <a href="#contact"
                   class="bg-amber-500 hover:bg-amber-600 text-white px-8 py-4 rounded-lg text-lg font-semibold shadow-lg hover:shadow-xl transition-all text-center transform hover:-translate-y-1">
                  Get Started Now
                </a>
                <a href="#how-it-works"
                   class="bg-white hover:bg-gray-50 text-blue-900 px-8 py-4 rounded-lg text-lg font-semibold shadow-lg hover:shadow-xl transition-all text-center border-2 border-blue-900 transform hover:-translate-y-1">
                  See How It Works
                </a>
              </div>
            </div>
            <div class="w-full md:w-1/2 flex justify-center">
              <div class="flex items-center space-x-4 sm:space-x-8">
                <!-- WordPress Icon with Ping -->
                <div class="text-center relative">
                  <div class="relative inline-block">
                    <i class="fab fa-wordpress text-[#21759b] text-4xl sm:text-6xl md:text-7xl hover:scale-110 transform transition-transform duration-300"></i>
                    <div
                        class="absolute -top-3 -left-3 sm:-top-4 sm:-left-4 w-[calc(100%+24px)] sm:w-[calc(100%+32px)] h-[calc(100%+24px)] sm:h-[calc(100%+32px)] rounded-full border-2 border-[#21759b] animate-ping-slow opacity-75"></div>
                  </div>
                </div>

                <!-- Sync Icon with Animation -->
                <div class="relative w-24 sm:w-32 md:w-48 text-center">
                  <i class="fas fa-sync-alt text-gray-500 text-3xl sm:text-4xl md:text-5xl animate-spin-slow hover:text-blue-700 transition-colors duration-300"></i>
                </div>

                <!-- Salesforce Icon with Ping -->
                <div class="text-center relative">
                  <div class="relative inline-block">
                    <i class="fab fa-salesforce text-[#00a1e0] text-4xl sm:text-6xl md:text-7xl hover:scale-110 transform transition-transform duration-300"></i>
                    <div
                        class="absolute -top-3 -left-3 sm:-top-4 sm:-left-4 w-[calc(100%+24px)] sm:w-[calc(100%+32px)] h-[calc(100%+24px)] sm:h-[calc(100%+32px)] rounded-full border-2 border-[#00a1e0] animate-ping-slow opacity-75"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Trust Badges -->
<section class="py-8 bg-gray-50">
        <div class="container mx-auto px-4">
          <div class="flex flex-wrap justify-center items-center gap-8">
            <div class="text-center">
              <div class="text-4xl font-bold text-blue-600">100+</div>
              <div class="text-gray-600">Projects Completed</div>
            </div>
            <div class="text-center">
              <div class="text-4xl font-bold text-blue-600">50+</div>
              <div class="text-gray-600">Happy Clients</div>
            </div>
            <div class="text-center">
              <div class="text-4xl font-bold text-blue-600">7+</div>
              <div class="text-gray-600">Years Experience</div>
            </div>
            <div class="text-center">
              <div class="text-4xl font-bold text-blue-600">24/7</div>
              <div class="text-gray-600">Support Available</div>
            </div>
          </div>
        </div>
      </section>


      <!-- Pain Points Section with Creative Layout -->
<section class="py-16 bg-white relative overflow-hidden">
        <!-- Background decorative elements -->
        <div class="absolute inset-0 bg-grid-pattern opacity-5"></div>
        <div class="container mx-auto px-4 relative">
          <h2 class="text-3xl md:text-4xl font-bold text-center mb-4">Common Integration Challenges We Solve</h2>
          <p class="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
            Are you facing any of these challenges with your current WordPress and Salesforce setup?
          </p>

          <!-- Central Hub Design -->
          <div class="relative max-w-6xl mx-auto">
            <!-- Center Circle -->
            <div class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-blue-600 rounded-full flex items-center justify-center z-10 shadow-xl border-4 border-white">
              <div class="text-white text-center p-4">
                <i class="fas fa-shield-alt text-3xl mb-2"></i>
                <h3 class="font-bold">Solutions Hub</h3>
                <p class="text-sm">Click challenges to learn more</p>
              </div>
            </div>

            <!-- Pain Points Grid -->
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 relative z-20">
              <!-- Manual Data Entry -->
              <div class="group bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300">
                <div class="flex items-start space-x-4">
                  <div class="flex-shrink-0 w-12 h-12 bg-red-100 rounded-full flex items-center justify-center group-hover:bg-red-200 transition-colors">
                    <i class="fas fa-keyboard text-red-500 text-xl"></i>
                  </div>
                  <div>
                    <h3 class="text-xl font-bold mb-2 text-gray-800">Manual Data Entry</h3>
                    <p class="text-gray-600">
                      Tired of copying data between systems manually?
                    </p>
                    <div class="mt-4 opacity-0 group-hover:opacity-100 transition-opacity">
                      <h4 class="font-semibold text-blue-600 mb-2">Our Solution:</h4>
                      <ul class="text-sm text-gray-600 space-y-1">
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Automated data synchronization
                        </li>
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Real-time updates
                        </li>
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Error-free data transfer
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Inconsistent Data -->
              <div class="group bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300">
                <div class="flex items-start space-x-4">
                  <div class="flex-shrink-0 w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center group-hover:bg-yellow-200 transition-colors">
                    <i class="fas fa-exclamation-triangle text-yellow-500 text-xl"></i>
                  </div>
                  <div>
                    <h3 class="text-xl font-bold mb-2 text-gray-800">Inconsistent Data</h3>
                    <p class="text-gray-600">
                      Struggling with mismatched information?
                    </p>
                    <div class="mt-4 opacity-0 group-hover:opacity-100 transition-opacity">
                      <h4 class="font-semibold text-blue-600 mb-2">Our Solution:</h4>
                      <ul class="text-sm text-gray-600 space-y-1">
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Automated data validation
                        </li>
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Conflict resolution
                        </li>
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Data integrity checks
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Complex Workflows -->
              <div class="group bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300">
                <div class="flex items-start space-x-4">
                  <div class="flex-shrink-0 w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center group-hover:bg-purple-200 transition-colors">
                    <i class="fas fa-project-diagram text-purple-500 text-xl"></i>
                  </div>
                  <div>
                    <h3 class="text-xl font-bold mb-2 text-gray-800">Complex Workflows</h3>
                    <p class="text-gray-600">
                      Need to automate multi-step processes?
                    </p>
                    <div class="mt-4 opacity-0 group-hover:opacity-100 transition-opacity">
                      <h4 class="font-semibold text-blue-600 mb-2">Our Solution:</h4>
                      <ul class="text-sm text-gray-600 space-y-1">
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Visual workflow builder
                        </li>
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Custom triggers & actions
                        </li>
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Process automation
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Performance Issues -->
              <div class="group bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300">
                <div class="flex items-start space-x-4">
                  <div class="flex-shrink-0 w-12 h-12 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                    <i class="fas fa-tachometer-alt text-green-500 text-xl"></i>
                  </div>
                  <div>
                    <h3 class="text-xl font-bold mb-2 text-gray-800">Performance Issues</h3>
                    <p class="text-gray-600">
                      Experiencing slow syncs or system lag?
                    </p>
                    <div class="mt-4 opacity-0 group-hover:opacity-100 transition-opacity">
                      <h4 class="font-semibold text-blue-600 mb-2">Our Solution:</h4>
                      <ul class="text-sm text-gray-600 space-y-1">
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Optimized sync engine
                        </li>
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Load balancing
                        </li>
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Resource management
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Security Concerns -->
              <div class="group bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300">
                <div class="flex items-start space-x-4">
                  <div class="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                    <i class="fas fa-lock text-blue-500 text-xl"></i>
                  </div>
                  <div>
                    <h3 class="text-xl font-bold mb-2 text-gray-800">Security Concerns</h3>
                    <p class="text-gray-600">
                      Worried about data protection?
                    </p>
                    <div class="mt-4 opacity-0 group-hover:opacity-100 transition-opacity">
                      <h4 class="font-semibold text-blue-600 mb-2">Our Solution:</h4>
                      <ul class="text-sm text-gray-600 space-y-1">
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          End-to-end encryption
                        </li>
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Access controls
                        </li>
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Audit logging
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Error Handling -->
              <div class="group bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300">
                <div class="flex items-start space-x-4">
                  <div class="flex-shrink-0 w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center group-hover:bg-orange-200 transition-colors">
                    <i class="fas fa-exclamation-circle text-orange-500 text-xl"></i>
                  </div>
                  <div>
                    <h3 class="text-xl font-bold mb-2 text-gray-800">Error Handling</h3>
                    <p class="text-gray-600">
                      Lost data due to failed syncs?
                    </p>
                    <div class="mt-4 opacity-0 group-hover:opacity-100 transition-opacity">
                      <h4 class="font-semibold text-blue-600 mb-2">Our Solution:</h4>
                      <ul class="text-sm text-gray-600 space-y-1">
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Automatic retry system
                        </li>
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Error notifications
                        </li>
                        <li class="flex items-center">
                          <i class="fas fa-check text-green-500 mr-2"></i>
                          Data recovery tools
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Connecting Lines (Visual Enhancement) -->
            <div class="absolute inset-0 pointer-events-none">
              <svg class="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
                <path d="M50 50 L20 20" stroke="rgba(59, 130, 246, 0.2)" stroke-width="0.5" />
                <path d="M50 50 L80 20" stroke="rgba(59, 130, 246, 0.2)" stroke-width="0.5" />
                <path d="M50 50 L20 80" stroke="rgba(59, 130, 246, 0.2)" stroke-width="0.5" />
                <path d="M50 50 L80 80" stroke="rgba(59, 130, 246, 0.2)" stroke-width="0.5" />
              </svg>
            </div>
          </div>

          <!-- Action Button -->
          <div class="text-center mt-16">
            <a href="#contact"
               class="inline-flex items-center px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transform hover:-translate-y-1 transition-all duration-300 shadow-lg hover:shadow-xl">
              <span>Solve Your Integration Challenges</span>
              <i class="fas fa-arrow-right ml-2"></i>
            </a>
          </div>
        </div>
      </section>



      <!-- How It Works -->
<section id="how-it-works" class="py-16 bg-gray-50">
        <div class="container mx-auto px-4">
          <h2 class="text-3xl font-bold text-center mb-16">How Our Integration Process Works</h2>
          <div class="relative">
            <div class="absolute hidden lg:block top-1/2 left-0 right-0 h-1 bg-blue-200 -translate-y-1/2"></div>
            <div class="grid grid-cols-1 lg:grid-cols-4 gap-8">
              <div class="relative bg-white p-6 rounded-lg shadow-md z-10">
                <div
                    class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">
                  1
                </div>
                <h3 class="text-xl font-bold text-center mt-6 mb-4">Discovery</h3>
                <p class="text-gray-600 text-center">We analyze your current setup and understand your specific
                  requirements</p>
              </div>
              <div class="relative bg-white p-6 rounded-lg shadow-md z-10">
                <div
                    class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">
                  2
                </div>
                <h3 class="text-xl font-bold text-center mt-6 mb-4">Planning</h3>
                <p class="text-gray-600 text-center">We design a custom integration solution tailored to your needs</p>
              </div>
              <div class="relative bg-white p-6 rounded-lg shadow-md z-10">
                <div
                    class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">
                  3
                </div>
                <h3 class="text-xl font-bold text-center mt-6 mb-4">Development</h3>
                <p class="text-gray-600 text-center">We build and test your integration in a staging environment</p>
              </div>
              <div class="relative bg-white p-6 rounded-lg shadow-md z-10">
                <div
                    class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">
                  4
                </div>
                <h3 class="text-xl font-bold text-center mt-6 mb-4">Deployment</h3>
                <p class="text-gray-600 text-center">We launch your integration with ongoing support and maintenance</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Features -->
<section class="py-16 bg-white">
        <div class="container mx-auto px-4">
          <h2 class="text-3xl font-bold text-center mb-16">Comprehensive Integration Features</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div class="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow duration-300">
              <div class="text-blue-500 mb-4">
                <i class="fas fa-sync-alt text-3xl"></i>
              </div>
              <h3 class="text-xl font-bold mb-4">Bi-directional Sync</h3>
              <p class="text-gray-600">
                Keep your WordPress and Salesforce data in perfect harmony with real-time, two-way synchronization.
              </p>
            </div>
            <div class="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow duration-300">
              <div class="text-blue-500 mb-4">
                <i class="fas fa-shield-alt text-3xl"></i>
              </div>
              <h3 class="text-xl font-bold mb-4">Secure Data Transfer</h3>
              <p class="text-gray-600">
                Enterprise-grade security measures ensure your sensitive data remains protected during transfer.
              </p>
            </div>
            <div class="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow duration-300">
              <div class="text-blue-500 mb-4">
                <i class="fas fa-tasks text-3xl"></i>
              </div>
              <h3 class="text-xl font-bold mb-4">Custom Workflows</h3>
              <p class="text-gray-600">
                Automate complex business processes with customized workflow rules and triggers.
              </p>
            </div>
            <div class="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow duration-300">
              <div class="text-blue-500 mb-4">
                <i class="fas fa-file-upload text-3xl"></i>
              </div>
              <h3 class="text-xl font-bold mb-4">File Management</h3>
              <p class="text-gray-600">
                Seamlessly handle file uploads and attachments between both platforms.
              </p>
            </div>
            <div class="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow duration-300">
              <div class="text-blue-500 mb-4">
                <i class="fas fa-user-lock text-3xl"></i>
              </div>
              <h3 class="text-xl font-bold mb-4">User Authentication</h3>
              <p class="text-gray-600">
                Secure user authentication and authorization between WordPress and Salesforce.
              </p>
            </div>
            <div class="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow duration-300">
              <div class="text-blue-500 mb-4">
                <i class="fas fa-chart-bar text-3xl"></i>
              </div>
              <h3 class="text-xl font-bold mb-4">Advanced Reporting</h3>
              <p class="text-gray-600">
                Generate comprehensive reports combining data from both platforms.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- Case Studies -->
      <section class="py-16 bg-gray-50">
        <div class="container mx-auto px-4">
          <h2 class="text-3xl font-bold text-center mb-16">Success Stories</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div class="bg-white rounded-lg overflow-hidden shadow-md">

              <!--              <img src="/api/placeholder/400/200" alt="Case Study 1" class="w-full h-48 object-cover">-->
              <div class="p-6">
                <h3 class="text-xl font-bold mb-4">E-commerce Integration</h3>
                <p class="text-gray-600 mb-4">
                  Helped an online retailer automate their order processing and customer management between WooCommerce
                  and Salesforce.
                </p>
                <div class="flex justify-between items-center text-sm text-gray-500">
                  <span>Processing time reduced by 75%</span>
                  <span>ROI: 300%</span>
                </div>
              </div>
            </div>
            <div class="bg-white rounded-lg overflow-hidden shadow-md">
              <!--              <img src="/api/placeholder/400/200" alt="Case Study 2" class="w-full h-48 object-cover">-->
              <div class="p-6">
                <h3 class="text-xl font-bold mb-4">Membership Portal</h3>
                <p class="text-gray-600 mb-4">
                  Built a custom membership portal for a professional association, synchronizing member data between
                  platforms.
                </p>
                <div class="flex justify-between items-center text-sm text-gray-500">
                  <span>10,000+ active members</span>
                  <span>99.9% uptime</span>
                </div>
              </div>
            </div>
            <div class="bg-white rounded-lg overflow-hidden shadow-md">
              <!--              <img src="/api/placeholder/400/200" alt="Case Study 3" class="w-full h-48 object-cover">-->
              <div class="p-6">
                <h3 class="text-xl font-bold mb-4">Lead Generation</h3>
                <p class="text-gray-600 mb-4">
                  Developed an automated lead capture and nurturing system for a B2B software company.
                </p>
                <div class="flex justify-between items-center text-sm text-gray-500">
                  <span>Leads increased by 150%</span>
                  <span>Conversion up 45%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section class="py-16 bg-white">
        <div class="container mx-auto px-4">
          <h2 class="text-3xl font-bold text-center mb-16">What Our Clients Say</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

            <!-- Testimonial 1 -->
            <div class="bg-gray-50 p-8 rounded-lg transform hover:scale-105 transition-transform duration-300 hover:shadow-xl">
              <div class="flex items-center mb-4">
                <div class="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                  <span class="text-blue-600 font-bold text-xl">SJ</span>
                </div>
                <div class="ml-4">
                  <h4 class="font-bold">Sarah Johnson</h4>
                  <p class="text-gray-600">Marketing Director</p>
                </div>
              </div>
              <div class="text-yellow-400 mb-4 animate-pulse">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </div>
              <p class="text-gray-600">
                "The custom integration Arrify built for us has transformed our marketing operations. We're saving hours each week on data entry and our lead response time has improved dramatically."
              </p>
            </div>

            <!-- Testimonial 2 -->
            <div class="bg-gray-50 p-8 rounded-lg transform hover:scale-105 transition-transform duration-300 hover:shadow-xl">
              <div class="flex items-center mb-4">
                <div class="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <span class="text-green-600 font-bold text-xl">MC</span>
                </div>
                <div class="ml-4">
                  <h4 class="font-bold">Michael Chen</h4>
                  <p class="text-gray-600">Operations Manager</p>
                </div>
              </div>
              <div class="text-yellow-400 mb-4 animate-pulse">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </div>
              <p class="text-gray-600">
                "The team at Arrify went above and beyond to understand our unique requirements. They delivered a solution that perfectly matches our workflow and scales with our growth."
              </p>
            </div>

            <!-- Testimonial 3 -->
            <div class="bg-gray-50 p-8 rounded-lg transform hover:scale-105 transition-transform duration-300 hover:shadow-xl">
              <div class="flex items-center mb-4">
                <div class="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                  <span class="text-purple-600 font-bold text-xl">ER</span>
                </div>
                <div class="ml-4">
                  <h4 class="font-bold">Emily Rodriguez</h4>
                  <p class="text-gray-600">IT Director</p>
                </div>
              </div>
              <div class="text-yellow-400 mb-4 animate-pulse">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </div>
              <p class="text-gray-600">
                "Outstanding technical expertise and support. Our WordPress-Salesforce integration has been running smoothly for over a year now, and any adjustments we need are handled promptly."
              </p>
            </div>

            <!-- Testimonial 4 -->
            <div class="bg-gray-50 p-8 rounded-lg transform hover:scale-105 transition-transform duration-300 hover:shadow-xl">
              <div class="flex items-center mb-4">
                <div class="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                  <span class="text-red-600 font-bold text-xl">DS</span>
                </div>
                <div class="ml-4">
                  <h4 class="font-bold">David Smith</h4>
                  <p class="text-gray-600">CEO</p>
                </div>
              </div>
              <div class="text-yellow-400 mb-4 animate-pulse">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </div>
              <p class="text-gray-600">
                "Arrify's integration solutions have been a game-changer for our business. The automation and efficiency gains have given us a significant competitive advantage in our market."
              </p>
            </div>

            <!-- Testimonial 5 -->
            <div class="bg-gray-50 p-8 rounded-lg transform hover:scale-105 transition-transform duration-300 hover:shadow-xl">
              <div class="flex items-center mb-4">
                <div class="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
                  <span class="text-yellow-600 font-bold text-xl">LT</span>
                </div>
                <div class="ml-4">
                  <h4 class="font-bold">Lisa Thompson</h4>
                  <p class="text-gray-600">Sales Director</p>
                </div>
              </div>
              <div class="text-yellow-400 mb-4 animate-pulse">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </div>
              <p class="text-gray-600">
                "The seamless integration between our WordPress site and Salesforce has revolutionized our sales process. Our team can now focus on closing deals instead of managing data."
              </p>
            </div>

            <!-- Testimonial 6 -->
            <div class="bg-gray-50 p-8 rounded-lg transform hover:scale-105 transition-transform duration-300 hover:shadow-xl">
              <div class="flex items-center mb-4">
                <div class="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center">
                  <span class="text-pink-600 font-bold text-xl">JW</span>
                </div>
                <div class="ml-4">
                  <h4 class="font-bold">James Wilson</h4>
                  <p class="text-gray-600">Digital Marketing Manager</p>
                </div>
              </div>
              <div class="text-yellow-400 mb-4 animate-pulse">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </div>
              <p class="text-gray-600">
                "We've seen a 40% increase in lead conversion since implementing Arrify's solution. Their attention to detail and customer support is exceptional."
              </p>
            </div>

          </div>
        </div>
      </section>


      <!-- Pricing -->
      <section class="py-16 bg-gray-50" id="pricing">
        <div class="container mx-auto px-4">
          <h2 class="text-3xl font-bold text-center mb-4">Pricing Options</h2>
          <p class="text-gray-600 text-center mb-16 max-w-2xl mx-auto">
            Choose from our pre-built integration packages or get a custom solution tailored to your needs. All packages include 7 days of support.
          </p>
          <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
            <!-- WP Form to Salesforce Lead -->
            <div class="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border-2 border-blue-500 relative">
              <div class="absolute top-0 right-0 bg-blue-500 text-white px-4 py-1 rounded-bl-lg">
                Popular
              </div>
              <h3 class="text-xl font-bold text-center mb-4">Web-to-Lead Form</h3>
              <div class="text-center mb-6">
                <span class="text-3xl font-bold">€239</span>
                <span class="text-gray-600">/one-time</span>
              </div>
              <ul class="space-y-3 mb-6 min-h-[160px]">
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>WordPress form to Salesforce Lead integration</span>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>Standard Salesforce fields only</span>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>7 days support included</span>
                </li>
              </ul>
              <a href="#contact"
                 class="block text-center bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-300">
                Get Started
              </a>
            </div>

            <!-- Display Salesforce Data -->
            <div class="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border-2 border-blue-500 relative">
              <div class="absolute top-0 right-0 bg-blue-500 text-white px-4 py-1 rounded-bl-lg">
                Popular
              </div>
              <h3 class="text-xl font-bold text-center mb-4">Display SF Data</h3>
              <div class="text-center mb-6">
                <span class="text-3xl font-bold">€359</span>
                <span class="text-gray-600">/one-time</span>
              </div>
              <ul class="space-y-3 mb-6 min-h-[160px]">
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>Display Salesforce data in WordPress</span>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>Single object, up to 8 fields</span>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>7 days support included</span>
                </li>
              </ul>
              <a href="#contact"
                 class="block text-center bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-300">
                Get Started
              </a>
            </div>

            <!-- User Creation from Contact -->
            <div class="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300">
              <h3 class="text-xl font-bold text-center mb-4">User Creation</h3>
              <div class="text-center mb-6">
                <span class="text-3xl font-bold">€559</span>
                <span class="text-gray-600">/one-time</span>
              </div>
              <ul class="space-y-3 mb-6 min-h-[160px]">
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>Create WordPress users from SF Contacts</span>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>Up to 8 fields, one-way sync</span>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>7 days support included</span>
                </li>
              </ul>
              <a href="#contact"
                 class="block text-center bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-300">
                Get Started
              </a>
            </div>

            <!-- Custom Object Integration -->
            <div class="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300">
              <h3 class="text-xl font-bold text-center mb-4">Custom Object</h3>
              <div class="text-center mb-6">
                <span class="text-3xl font-bold">€439</span>
                <span class="text-gray-600">/one-time</span>
              </div>
              <ul class="space-y-3 mb-6 min-h-[160px]">
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>WordPress form to SF Custom Object</span>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>Up to 8 custom fields</span>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>7 days support included</span>
                </li>
              </ul>
              <a href="#contact"
                 class="block text-center bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-300">
                Get Started
              </a>
            </div>

            <!-- Custom Solution -->
            <div class="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300">
              <h3 class="text-xl font-bold text-center mb-4">Custom Solution</h3>
              <div class="text-center mb-6">
                <span class="text-2xl font-bold">Contact Us</span>
                <span class="text-gray-600 block">For Custom Needs</span>
              </div>
              <ul class="space-y-3 mb-6 min-h-[160px]">
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>Fully customized integration</span>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>Complex workflows & automations</span>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-check text-green-500 mr-2 mt-1"></i>
                  <span>Flexible support options</span>
                </li>
              </ul>
              <a href="#contact"
                 class="block text-center bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-300">
                Contact Us
              </a>
            </div>
          </div>

          <!-- Additional Info -->
          <div class="mt-12 text-center">
            <p class="text-gray-600">
              All packages include detailed documentation and implementation support.
              <a href="#contact" class="text-blue-600 hover:text-blue-700 font-medium">Contact us</a> for a custom solution.
            </p>
          </div>
        </div>
      </section>


      <!-- FAQ -->
      <section class="py-16 bg-white">
        <div class="container mx-auto px-4">
          <h2 class="text-3xl font-bold text-center mb-16">Frequently Asked Questions</h2>
          <div class="max-w-3xl mx-auto space-y-6">

            <!-- FAQ Item 1 -->
            <div class="bg-gray-50 rounded-lg overflow-hidden">
              <button @click="$refs.faq1.style.maxHeight = $refs.faq1.style.maxHeight ? null : $refs.faq1.scrollHeight + 'px'"
                      class="w-full p-6 text-left flex justify-between items-center hover:bg-gray-100 transition-colors duration-300">
                <h3 class="text-xl font-bold">How long does the integration process take?</h3>
                <i class="fas fa-chevron-down transform transition-transform duration-300"
                   :class="{'rotate-180': $refs.faq1?.style.maxHeight}"></i>
              </button>
              <div ref="faq1" class="max-h-0 overflow-hidden transition-all duration-300">
                <p class="text-gray-600 p-6 pt-0">
                  The timeline varies depending on your specific requirements. A basic integration typically takes 2-3
                  weeks, while more complex solutions may take 4-8 weeks. We'll provide a detailed timeline during the
                  discovery phase.
                </p>
              </div>
            </div>

            <!-- FAQ Item 2 -->
            <div class="bg-gray-50 rounded-lg overflow-hidden">
              <button @click="$refs.faq2.style.maxHeight = $refs.faq2.style.maxHeight ? null : $refs.faq2.scrollHeight + 'px'"
                      class="w-full p-6 text-left flex justify-between items-center hover:bg-gray-100 transition-colors duration-300">
                <h3 class="text-xl font-bold">Do you provide ongoing support?</h3>
                <i class="fas fa-chevron-down transform transition-transform duration-300"
                   :class="{'rotate-180': $refs.faq2?.style.maxHeight}"></i>
              </button>
              <div ref="faq2" class="max-h-0 overflow-hidden transition-all duration-300">
                <p class="text-gray-600 p-6 pt-0">
                  Yes, all our integration packages include a support period. We also offer extended support plans for
                  ongoing maintenance and updates. Our support team is available 24/7 to address any issues or concerns.
                </p>
              </div>
            </div>

            <!-- FAQ Item 3 -->
            <div class="bg-gray-50 rounded-lg overflow-hidden">
              <button @click="$refs.faq3.style.maxHeight = $refs.faq3.style.maxHeight ? null : $refs.faq3.scrollHeight + 'px'"
                      class="w-full p-6 text-left flex justify-between items-center hover:bg-gray-100 transition-colors duration-300">
                <h3 class="text-xl font-bold">Can you customize the integration to match our workflow?</h3>
                <i class="fas fa-chevron-down transform transition-transform duration-300"
                   :class="{'rotate-180': $refs.faq3?.style.maxHeight}"></i>
              </button>
              <div ref="faq3" class="max-h-0 overflow-hidden transition-all duration-300">
                <p class="text-gray-600 p-6 pt-0">
                  Absolutely! Our solutions are fully customized to match your specific business processes and
                  requirements. We don't believe in one-size-fits-all approaches. We'll work closely with your team to
                  understand your workflows and create a solution that fits perfectly.
                </p>
              </div>
            </div>

            <!-- FAQ Item 4 -->
            <div class="bg-gray-50 rounded-lg overflow-hidden">
              <button @click="$refs.faq4.style.maxHeight = $refs.faq4.style.maxHeight ? null : $refs.faq4.scrollHeight + 'px'"
                      class="w-full p-6 text-left flex justify-between items-center hover:bg-gray-100 transition-colors duration-300">
                <h3 class="text-xl font-bold">Is the integration secure?</h3>
                <i class="fas fa-chevron-down transform transition-transform duration-300"
                   :class="{'rotate-180': $refs.faq4?.style.maxHeight}"></i>
              </button>
              <div ref="faq4" class="max-h-0 overflow-hidden transition-all duration-300">
                <p class="text-gray-600 p-6 pt-0">
                  Security is our top priority. We implement industry-standard security measures and follow best practices
                  for data protection. All data transfers are encrypted and secure. We also regularly perform security
                  audits and updates to ensure your data remains protected.
                </p>
              </div>
            </div>

            <!-- FAQ Item 5 -->
            <div class="bg-gray-50 rounded-lg overflow-hidden">
              <button @click="$refs.faq5.style.maxHeight = $refs.faq5.style.maxHeight ? null : $refs.faq5.scrollHeight + 'px'"
                      class="w-full p-6 text-left flex justify-between items-center hover:bg-gray-100 transition-colors duration-300">
                <h3 class="text-xl font-bold">What happens if something goes wrong?</h3>
                <i class="fas fa-chevron-down transform transition-transform duration-300"
                   :class="{'rotate-180': $refs.faq5?.style.maxHeight}"></i>
              </button>
              <div ref="faq5" class="max-h-0 overflow-hidden transition-all duration-300">
                <p class="text-gray-600 p-6 pt-0">
                  We have robust error handling and monitoring systems in place. If any issues arise, our support team is
                  notified immediately and will work to resolve them. We also maintain regular backups and can quickly
                  restore functionality if needed. Our SLA guarantees response times based on issue severity.
                </p>
              </div>
            </div>

            <!-- FAQ Item 6 -->
            <div class="bg-gray-50 rounded-lg overflow-hidden">
              <button @click="$refs.faq6.style.maxHeight = $refs.faq6.style.maxHeight ? null : $refs.faq6.scrollHeight + 'px'"
                      class="w-full p-6 text-left flex justify-between items-center hover:bg-gray-100 transition-colors duration-300">
                <h3 class="text-xl font-bold">Can we migrate existing data?</h3>
                <i class="fas fa-chevron-down transform transition-transform duration-300"
                   :class="{'rotate-180': $refs.faq6?.style.maxHeight}"></i>
              </button>
              <div ref="faq6" class="max-h-0 overflow-hidden transition-all duration-300">
                <p class="text-gray-600 p-6 pt-0">
                  Yes, we can help migrate your existing data as part of the integration process. We'll create a detailed
                  migration plan, perform thorough testing in a staging environment, and ensure all your historical data
                  is properly transferred and mapped between systems.
                </p>
              </div>
            </div>

            <!-- FAQ Item 7 -->
            <div class="bg-gray-50 rounded-lg overflow-hidden">
              <button @click="$refs.faq7.style.maxHeight = $refs.faq7.style.maxHeight ? null : $refs.faq7.scrollHeight + 'px'"
                      class="w-full p-6 text-left flex justify-between items-center hover:bg-gray-100 transition-colors duration-300">
                <h3 class="text-xl font-bold">What kind of training do you provide?</h3>
                <i class="fas fa-chevron-down transform transition-transform duration-300"
                   :class="{'rotate-180': $refs.faq7?.style.maxHeight}"></i>
              </button>
              <div ref="faq7" class="max-h-0 overflow-hidden transition-all duration-300">
                <p class="text-gray-600 p-6 pt-0">
                  We provide comprehensive training for your team as part of the implementation process. This includes
                  documentation, video tutorials, and live training sessions. We'll ensure your team is comfortable using
                  the integrated systems and knows how to handle common scenarios.
                </p>
              </div>
            </div>

            <!-- FAQ Item 8 -->
            <div class="bg-gray-50 rounded-lg overflow-hidden">
              <button @click="$refs.faq8.style.maxHeight = $refs.faq8.style.maxHeight ? null : $refs.faq8.scrollHeight + 'px'"
                      class="w-full p-6 text-left flex justify-between items-center hover:bg-gray-100 transition-colors duration-300">
                <h3 class="text-xl font-bold">Can the integration be scaled as we grow?</h3>
                <i class="fas fa-chevron-down transform transition-transform duration-300"
                   :class="{'rotate-180': $refs.faq8?.style.maxHeight}"></i>
              </button>
              <div ref="faq8" class="max-h-0 overflow-hidden transition-all duration-300">
                <p class="text-gray-600 p-6 pt-0">
                  Yes, our integrations are designed to scale with your business. We build flexibility into the system
                  to accommodate growth in data volume, users, and functionality. We can also add new features and
                  capabilities as your needs evolve.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <!-- Contact Form Section with Enhanced Styling -->
      <section id="contact" class="relative py-20 bg-gradient-to-br from-blue-50 to-white">
        <div class="absolute inset-0 bg-grid-pattern opacity-5"></div>
        <div class="container mx-auto px-4 relative">
          <div class="max-w-3xl mx-auto">
            <div class="text-center mb-12">
              <span class="inline-block px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-semibold mb-4">Let's Connect</span>
              <h2 class="text-4xl font-bold text-blue-900 mb-4">Get Your Custom Integration Solution</h2>
              <p class="text-xl text-gray-600">Tell us about your project and we'll get back to you within 24 hours.</p>
            </div>

            <!-- Existing Contact Form -->
            <div class="bg-white rounded-2xl shadow-xl p-8 transform hover:shadow-2xl transition-all duration-300">
              <client-only>
                <ContactForm
                    :formId="4"
                    :storedData="storedCtaData"
                />
              </client-only>
            </div>
          </div>
        </div>
      </section>


      <!-- Final CTA -->
      <section class="relative py-20 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
        <!-- Decorative background pattern -->
        <div class="absolute inset-0 bg-grid-pattern opacity-10"></div>

        <div class="container mx-auto px-4">
          <div class="relative z-10 max-w-4xl mx-auto">
            <!-- Main content -->
            <div class="text-center mb-12">
        <span class="inline-block px-4 py-2 bg-blue-700 text-white rounded-full text-sm font-semibold mb-6">
          Take the Next Step
        </span>
              <h2 class="text-4xl md:text-5xl font-bold text-white mb-6">
                Ready to Transform Your Business Integration?
              </h2>
              <p class="text-xl text-blue-100 mb-12 max-w-2xl mx-auto">
                Join hundreds of businesses that have streamlined their operations with our custom WordPress-Salesforce solutions.
              </p>

              <!-- CTA Buttons -->
              <div class="flex flex-col sm:flex-row gap-6 justify-center">
                <a href="#contact"
                   class="inline-flex items-center px-8 py-4 bg-amber-500 hover:bg-amber-600 text-white rounded-lg font-semibold shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1">
                  <span>Schedule a Free Consultation</span>
                  <i class="fas fa-arrow-right ml-2"></i>
                </a>
                <a href="#pricing"
                   class="inline-flex items-center px-8 py-4 bg-white hover:bg-gray-50 text-blue-900 rounded-lg font-semibold shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1">
                  <span>View Integration Packages</span>
                  <i class="fas fa-chevron-right ml-2"></i>
                </a>
              </div>

              <!-- Trust Indicators -->
              <div class="mt-12 pt-12 border-t border-blue-700">
                <div class="flex flex-wrap justify-center items-center gap-8 text-blue-100">
                  <div class="flex items-center">
                    <i class="fas fa-shield-alt text-amber-500 mr-2"></i>
                    <span>Enterprise-Grade Security</span>
                  </div>
                  <div class="flex items-center">
                    <i class="fas fa-clock text-amber-500 mr-2"></i>
                    <span>24/7 Support Available</span>
                  </div>
                  <div class="flex items-center">
                    <i class="fas fa-check-circle text-amber-500 mr-2"></i>
                    <span>100% Satisfaction Guaranteed</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>
    <FooterComponent/>
  </div>
</template>

<script setup>
import HeaderComponent from "../components/Header.vue";
import FooterComponent from "../components/Footer.vue";
import {useHead} from '@vueuse/head';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ContactForm from "~/components/ContactForm.vue";

useHead({
  title: 'Custom Salesforce-WordPress Integration Solutions - Arrify',
  meta: [
    {
      name: 'description',
      content: 'Transform your business with custom Salesforce-WordPress integrations. Get tailor-made solutions that perfectly match your requirements.'
    },
    {name: 'robots', content: 'follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large'},
    {property: 'og:locale', content: 'en_US'},
    {property: 'og:type', content: 'website'},
    {property: 'og:title', content: 'Custom Salesforce-WordPress Integration Solutions - Arrify'},
    {
      property: 'og:description',
      content: 'Transform your business with custom Salesforce-WordPress integrations. Get tailor-made solutions that perfectly match your requirements.'
    },
    {property: 'og:url', content: 'https://arrify.com/services'},
    {property: 'og:site_name', content: 'Arrify'}
  ],
  link: [
    {rel: 'canonical', href: 'https://arrify.com/services'}
  ]
});
</script>

<style>
@keyframes spin-slow {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin-slow {
  animation: spin-slow 3s linear infinite;
}

.animate-ping-slow {
  animation: ping 2s cubic-bezier(0, 0, 0.2, 1) infinite;
}

@keyframes ping {
  75%, 100% {
    transform: scale(1.5);
    opacity: 0;
  }
}


/* Add to your existing styles */
.bg-grid-pattern {
  background-image: linear-gradient(90deg, rgba(0,0,0,.1) 1px, transparent 1px),
  linear-gradient(rgba(0,0,0,.1) 1px, transparent 1px);
  background-size: 24px 24px;
}

/* Optional: Add these animations if you want some subtle movement */
@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.hover\:float:hover {
  animation: float 3s ease-in-out infinite;
}

.bg-grid-pattern {
  background-image: linear-gradient(90deg, rgba(59, 130, 246, 0.1) 1px, transparent 1px),
  linear-gradient(rgba(59, 130, 246, 0.1) 1px, transparent 1px);
  background-size: 20px 20px;
}

/* Additional hover effects */
.group:hover .flex-shrink-0 {
  transform: scale(1.1);
  transition: transform 0.3s ease;
}
</style>